module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-external-368fad7c5e7b2aa7807afc27153701c3.svg";